import React from 'react';
import { ILocalKindergarten } from 'utils/entities';
import { KindergartensWrapper, KindergartenContainer, SectionWrapper, SectionHeader } from '../styled';
import { useLocale } from 'locale';
import { SmallText, H3 } from 'ds/components/typography';

interface KindergartensProps {
  data: ILocalKindergarten[];
  areaName?: string;
}

export const Kindergartens: React.FC<KindergartensProps> = ({ data, areaName = null }) => {
  const { t } = useLocale();
  return (
    <SectionWrapper data-auto="kindergartens-section">
      <SectionHeader>
        <H3 weight="bold">{t('localPage.kindergartens.title', { areaName })}</H3>
      </SectionHeader>
      <KindergartensWrapper data-auto="kindergartens">
        {data.slice(0, 6).map(k => (
          <KindergartenContainer key={k.name}>
            <SmallText weight="bold">
              {k.name}
            </SmallText>
            <SmallText>
              {t('localPage.kindergartens.educationSystem')}: {k.educationSystem}
            </SmallText>
            <SmallText>
              {t('localPage.kindergartens.organization')}: {k.organization}
            </SmallText>
            <SmallText>
              {t('localPage.kindergartens.address')}: {k.address}
            </SmallText>
          </KindergartenContainer>
        ))}
      </KindergartensWrapper>
    </SectionWrapper>
  );
};
